<template>
	<div class="relative">
		<input
			ref="inputRef"
			:value="modelValue"
			type="text"
			placeholder="ex: User Experience Designer"
			class="
				w-full rounded-lg border border-[#C2C4C6] py-2 pr-8 pl-3 text-md
				leading-[22px] font-medium placeholder:text-won-dark-gray focus:border-won-green
				focus:ring-0 focus:outline-hidden
			"
			:class="[
				isSelected
					? 'border-won-green bg-won-green-hover text-won-green'
					: isDisabled
						? 'border-won-sand-light bg-won-sand-light text-won-dark-blue'
						: 'border-[#C2C4C6] text-won-dark-blue',
			]"
			@focus="focusHandler"
			@blur="blurHandler"
			@input="$emit('update:modelValue', $event.target.value)"
			@keyup.enter="$emit('confirm:modelValue', $event.target.value)"
		/>
		<button @click="focusHandler">
			<PencilIcon
				class="absolute top-1/2 right-3 size-4 -translate-y-1/2 transition-colors"
				:class="[
					isFocused || isSelected
						? 'text-won-green'
						: isDisabled
							? 'text-dark-100'
							: 'text-won-dark-gray'
				]"
			/>
		</button>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { PencilIcon } from '@heroicons/vue/24/solid';

const isFocused = ref(false);

defineProps({
	isSelected: {
		type: Boolean,
		default: true,
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	modelValue: {
		type: String,
		default: '',
	},
});

const emit = defineEmits(['update:modelValue', 'confirm:modelValue', 'focus:modelValue']);
const inputRef = ref(null);

const blurHandler = () => {
	isFocused.value = false;

	emit('confirm:modelValue');
};

const focusHandler = () => {
	inputRef.value?.focus();
	isFocused.value = true;

	emit('focus:modelValue');
};
</script>
